'use client'

import DynamicIcon from '@/components/DynamicIcon'
import { Button } from '@/components/ui/button'
import { useLegislativeContext } from '@/providers/LegislativeProvider'
import { cn } from '@/utilities/ui'

import type { IconName } from '@/components/DynamicIcon'
import type { Topic } from '@/payload-types'

export const FilterButton = ({
  topic,
  handleTopicClick,
  selectedBillTopics,
}: {
  topic: Topic
  handleTopicClick: (topic: Topic | null) => void
  selectedBillTopics: Topic[]
}) => {
  const { billTopicCounts } = useLegislativeContext()
  const isSelected = selectedBillTopics.includes(topic)

  // Use server-provided counts (accurate even beyond the 1000 item limit)
  // const totalBills = billTopicCounts[topic.id] ?? 0
  const totalBills = billTopicCounts !== undefined ? (billTopicCounts[topic.id] ?? 0) : 0

  return (
    <Button
      key={topic.id}
      variant="filter"
      className={cn(isSelected && 'selected')}
      onClick={() => handleTopicClick(topic)}
      disabled={Boolean(totalBills === 0) ?? undefined}
    >
      <span className="flex items-center gap-2">
        <DynamicIcon name={topic.icon as IconName} className="size-4.5" />
        {topic.title}
      </span>
      <span className="text-xs font-normal">{totalBills}</span>
    </Button>
  )
}
